export const logError = (err, location = 'General') => {
    if (["development", 'testing'].includes(process.env.REACT_APP_ENV)) {
        console.error(location + ': ' + err)
        if (err && typeof err === 'object' && 'stack' in err)
            console.log(err.stack)
    }
}
